/* eslint-disable no-unused-vars */
/* eslint-disable react/display-name */

import React, { useState, useMemo } from 'react'
import MaterialTable from 'material-table'
import { useDispatch, useSelector } from 'react-redux'
import { CreatorsAnchors } from '../../../../store/ducks/anchors'

import {
  Button
} from '@material-ui/core'
import { Link } from 'react-router-dom'

import VisibilityIcon from '@material-ui/icons/Visibility'
import EditIcon from '@material-ui/icons/Edit'
import CloseIcon from '@material-ui/icons/Close'

import { findPermission } from '../../../../services/auth'

import useStyles from './style'

function GridAncorasTaxasFaixas ({
  ancoraId,
  ancoraName,
  visualize,
  getAncorasTaxasFaixas,
  findAllAncorasTaxasFaixas
}) {
  const classes = useStyles()

  const { filters } = useSelector(state => state.anchors)
  const anchorFilter = filters.find(x => x.anchor === 'ancoras-taxas-faixas')
  const dispatch = useDispatch()

  const memoizedTable = useMemo(() => (
    <MaterialTable
      className={classes.table}
      options={{
        showTitle: false,
        search: false,
        toolbar: false,
        headerStyle: {
          backgroundColor: '#F5F5F5',
          textTransform: 'none',
          fontSize: '15px'
        },
        filtering: true,
        paging: false
      }}
      title="Multiple Actions Preview"
      columns={[
        {
          title: 'Valor Inicial',
          field: 'valorInicial',
          cellStyle: {
            fontSize: '13px',
            padding: '8px 16px'
          }
        },
        {
          title: 'Valor Final',
          field: 'valorFinal',
          cellStyle: {
            fontSize: '13px',
            padding: '8px 16px'
          }
        },
        {
          title: 'Taxa',
          field: 'taxa',
          cellStyle: {
            fontSize: '13px',
            padding: '8px 16px'
          }
        },
        {
          title: 'Status',
          field: 'status',
          cellStyle: {
            fontSize: '13px',
            padding: '8px 16px'
          },
          filtering: false
        },
        {
          title: 'Ações',
          field: 'actions',
          cellStyle: {
            fontSize: '13px',
            textAlign: 'center',
            padding: '8px 16px'
          },
          filtering: false,
          sorting: false,
          render: rowData => !!rowData.ancoraTaxaFaixaId && (
            <>
            {(!!findPermission(1828, 'Consultar')) && (<Link className={classes.buttonVisualize} to={`/app/ancoras-taxas-faixas/visualizar/${rowData.ancoraTaxaFaixaId}`}>
              <VisibilityIcon style={{ fontSize: 30, color: '#4AAF05' }}/>
            </Link>)}
            {(!!findPermission(1828, 'Alterar')) && !visualize && (<Link className={classes.buttonEdit} to={`/app/ancoras-taxas-faixas/editar/${rowData.ancoraTaxaFaixaId}`}>
              <EditIcon style={{ fontSize: 30, color: '#FB8832' }}/>
            </Link>)}
            </>
          )
        }
      ]}
      data={getAncorasTaxasFaixas}
    />
  ), [getAncorasTaxasFaixas])

  return (
    <>
      <div className={classes.actions}>
        <Button variant="contained" onClick={() => dispatch(CreatorsAnchors.changeModal({ anchor: 'ancoras-taxas-faixas' }))} className={classes.button}>
          <span>Filtros</span>
        </Button>
        {!visualize && !!findPermission(1828, 'Cadastrar') && (<Link className={classes.button} to={`/app/ancoras-taxas-faixas/${ancoraId}/cadastrar`}>Novo Item</Link>)}
        {!!anchorFilter.open && (
          <div className={classes.filtersBox}>
            <div className={classes.headFilter}>
              <span className={classes.labelFilter}>Status:</span>
              <button className={classes.buttonClose} onClick={() => dispatch(CreatorsAnchors.changeModal({ anchor: 'ancoras-taxas-faixas' }))}>
                <CloseIcon style={{ fontSize: 25, color: '#fff' }}/>
              </button>
            </div>
            <select onChange={(event) => dispatch(CreatorsAnchors.changeFilter({ anchor: 'ancoras-taxas-faixas', filter: event.target.value }))} value={anchorFilter.filter} className={classes.selectStatus}>
              <option value="">Todos</option>
              <option value="Ativo">Ativo</option>
              <option value="Inativo">Inativo</option>
            </select>
            <button className={classes.buttonFilter} onClick={() => findAllAncorasTaxasFaixas()}>Aplicar Filtro</button>
          </div>
        )}
      </div>
    {memoizedTable}
    </>
  )
}

export default GridAncorasTaxasFaixas
